import { ChannelLineupSubHeaderProps } from './ChannelLineupSubHeader/types'
import { ChannelLineupTableProps } from './ChannelLineupTable/types'

export interface ReactChannelLineupProps extends ChannelLineupSubHeaderProps, ChannelLineupTableProps {
  isInEditor?: boolean
  channelLineupLayout: ChannelLineupLayout
  heading?: string
  disclaimer?: string
  pkg?: string

  searchNoMatchMsg?: string
  searchNoMatchMsgIcon?: string
  searchNoMatchMsgIconAlt?: string
  errorMsg?: string
  errorMsgIcon?: string
  errorMsgIconAlt?: string

  top?: boolean
  right?: boolean
  bottom?: boolean
  left?: boolean
  lob?: string
}

export enum ChannelLineupLayout {
  DESKTOP = 'desktop',
  MOBILE = 'mobile',
  MODAL = 'modal'
}
